module.exports = __webpack_public_path__ + "static/media/skill-react-native.4bf96e61.png";